module.exports = __webpack_public_path__ + "static/easiest-admin-2021-187e815a211855cc6f655388de2b8636.svg";